import { ProductListPage } from './ProductList.page';

export const productListRouter = {
  '/@/products': ProductListPage,
};
